import React from 'react';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  question: string;
  userAnswer: string;
  hurdleQuestion?: string;
  hurdleAnswer?: string;
}

const AnswerModal: React.FC<Props> = ({ isOpen, onClose, question, userAnswer, hurdleQuestion, hurdleAnswer }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-6 animate-in fade-in duration-300">
      <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm" onClick={onClose}></div>
      <div className="relative w-full max-w-4xl bg-white rounded-[3rem] shadow-2xl overflow-hidden animate-in zoom-in-95 duration-300 max-h-[90vh] flex flex-col">

        <div className="p-10 border-b border-slate-100 flex justify-between items-center shrink-0">
          <div>
            <h2 className="text-2xl font-black text-slate-900 tracking-tight">Your Answer</h2>
            <p className="text-slate-500 text-xs font-medium uppercase tracking-widest mt-1">Review your response</p>
          </div>
          <button onClick={onClose} className="p-3 bg-slate-100 text-slate-400 hover:text-slate-900 rounded-full transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>

        <div className="p-10 space-y-8 flex-grow overflow-y-auto">
          {/* Main Question */}
          <div className="bg-blue-50 p-6 rounded-[2rem] border border-blue-100">
            <h3 className="text-[10px] font-black text-blue-600 uppercase tracking-widest mb-4">Question</h3>
            <p className="text-lg font-bold text-slate-800 leading-relaxed">{question}</p>
          </div>

          {/* User's Initial Answer */}
          <div className="bg-emerald-50 p-6 rounded-[2rem] border border-emerald-100">
            <h3 className="text-[10px] font-black text-emerald-600 uppercase tracking-widest mb-4">Your Initial Answer</h3>
            <div className="text-sm font-medium text-slate-700 leading-relaxed whitespace-pre-wrap">
              {userAnswer || "No answer provided"}
            </div>
          </div>

          {/* Hurdle Question and Answer */}
          {hurdleQuestion && (
            <>
              <div className="bg-amber-50 p-6 rounded-[2rem] border border-amber-100">
                <h3 className="text-[10px] font-black text-amber-600 uppercase tracking-widest mb-4">Hurdle Challenge</h3>
                <p className="text-lg font-bold text-amber-900 leading-relaxed italic">"{hurdleQuestion}"</p>
              </div>

              <div className="bg-amber-50 p-6 rounded-[2rem] border border-amber-100">
                <h3 className="text-[10px] font-black text-amber-600 uppercase tracking-widest mb-4">Your Hurdle Response</h3>
                <div className="text-sm font-medium text-slate-700 leading-relaxed whitespace-pre-wrap">
                  {hurdleAnswer || "No response provided"}
                </div>
              </div>
            </>
          )}
        </div>

        <div className="p-10 border-t border-slate-100 shrink-0">
          <button
            onClick={onClose}
            className="w-full bg-slate-900 text-white py-4 rounded-2xl font-black text-sm uppercase tracking-widest shadow-xl hover:bg-blue-600 transition-all"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnswerModal;
